import { OfficeTypeEnum, Search } from "@/types/types";
import styles from "../page-searchbar.module.css";
import { useEffect, useRef, useState } from "react";
import { useDropdownPosition } from "@/hooks/use-dropdown-position";
import SelectorComponentListItem from "@/components/searchbars/selector-component-list-item";
import { usePageStore } from "../../../usePageStore";
import { IoIosArrowDown } from "react-icons/io";

export default function OfficeTypeSelectorClient({
  t,
  updateSearch,
  refetchState,
  fullWidth,
  isMobileStyle,
}: {
  t: any;
  updateSearch: <K extends keyof Search>(key: K, value: Search[K]) => void;
  refetchState: () => Promise<void>;
  fullWidth?: boolean;
  isMobileStyle?: boolean;
}) {
  const [isOfficeTypeOpen, setIsOfficeTypeOpen] = useState(false);
  const officeTypeListRef = useRef<HTMLDivElement>(null);
  const officeTypeListStyles = useDropdownPosition(
    officeTypeListRef,
    isOfficeTypeOpen,
    {
      customWidth: 180, // px
      fullWidth: fullWidth,
    }
  );
  const activeOfficeType = usePageStore((state) => state.search.office_type);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        officeTypeListRef.current &&
        !officeTypeListRef.current.contains(event.target as Node)
      ) {
        setIsOfficeTypeOpen(false); //this will close it
      }
    };
    if (isOfficeTypeOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOfficeTypeOpen]);

  return (
    <div
      className={`${styles.selectWrapper} ${styles.officeTypeItemWrapper} ${
        fullWidth && styles.fullWidth
      } ${isMobileStyle && styles.mobile}`}
      ref={officeTypeListRef}
    >
      <button
        onClick={(e) => {
          e.preventDefault();
          setIsOfficeTypeOpen(!isOfficeTypeOpen);
        }}
        className={`${styles.pill} ${isOfficeTypeOpen && styles.pillOpen}`}
      >
        <div className={styles.textWrapper}>
          <span>
            {activeOfficeType !== null && activeOfficeType !== undefined
              ? t(activeOfficeType)
              : t("officeTypeTitle")}
          </span>
        </div>
        <span className={styles.chevron}>
          <IoIosArrowDown />
        </span>
      </button>
      {isOfficeTypeOpen && officeTypeListStyles.top && (
        <ul className={`${styles.selectionList}`} style={officeTypeListStyles}>
          <SelectorComponentListItem
            text={t("any")}
            icon={null}
            isActive={
              activeOfficeType === null || activeOfficeType === undefined
            }
            onClick={async () => {
              updateSearch("office_type", null);
              setIsOfficeTypeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
          <SelectorComponentListItem
            text={t(OfficeTypeEnum.CUBICLES)}
            icon={null}
            isActive={activeOfficeType === OfficeTypeEnum.CUBICLES}
            onClick={async () => {
              updateSearch("office_type", OfficeTypeEnum.CUBICLES);
              setIsOfficeTypeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
          <SelectorComponentListItem
            text={t(OfficeTypeEnum.OPEN_SPACE)}
            icon={null}
            isActive={activeOfficeType === OfficeTypeEnum.OPEN_SPACE}
            onClick={async () => {
              updateSearch("office_type", OfficeTypeEnum.OPEN_SPACE);
              setIsOfficeTypeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
          <SelectorComponentListItem
            text={t(OfficeTypeEnum.TEAM_CLUSTER)}
            icon={null}
            isActive={activeOfficeType === OfficeTypeEnum.TEAM_CLUSTER}
            onClick={async () => {
              updateSearch("office_type", OfficeTypeEnum.TEAM_CLUSTER);
              setIsOfficeTypeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
          <SelectorComponentListItem
            text={t(OfficeTypeEnum.TRADITIONAL)}
            icon={null}
            isActive={activeOfficeType === OfficeTypeEnum.TRADITIONAL}
            onClick={async () => {
              updateSearch("office_type", OfficeTypeEnum.TRADITIONAL);
              setIsOfficeTypeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
        </ul>
      )}
    </div>
  );
}
